import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import Store from '@/pages/store'
import Search from '@/pages/search'
import OrderDetail from '@/pages/order-detail' // 头没改
import LookCode from '@/pages/look-code'
import OrderRefund from '@/pages/order-refund'
import ShoppingCar from '@/pages/shopping-car'
import NoMatch from '@/pages/no-match/no-match'
import OrderRoute from '@/pages/fill-order'
import SelectStore from '@/pages/select-store'
import GoodsDetail from '@/pages/goods-detail'
import OrderList from '@/pages/order-list/order-list'
import Payment from '@/pages/payment'
import Book from '@/pages/book'
import SwitchBed from '@/pages/switch-bed/switch-bed'
import PersonSetting from '@/pages/person-setting/person-setting'
import ChangePwd from '@/pages/change-pwd/change-pwd'
import MyIntegral from '@/pages/my-integral/my-integral'
import EarnPoints from '@/pages/earn-points/earn-points'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import MyCoupon from '@/pages/my-coupon/my-coupon'
import BasicInformation from '@/pages/basic-information/basic-information'
import Notification from '@/pages/notification'
import KeepAlive from 'react-activation'
import Repair from '@/pages/repair'
import ServiceAgreement from '@/pages/service-agreement/service-agreement'
import Protocol from '@/pages/protocol/protocol'
import AboutUs from '@/pages/about-us/about-us'
import Privacy from '@/pages/privacy/privacy'
import DownloadPage from '@/pages/download-page/download-page';
import Sany from "@/pages/sanyi/sany-route";

export default withRouter(({ location, history }) => {

  if (location.pathname) {
    if ((window as any)['_hmt']) {
      ; (window as any)['_hmt'].push(['_trackPageview', location.pathname])
    }
    if (history.action === 'POP') {
      if (window.WebViewBridge) {
        window.WebViewBridge?.pageGoBack?.call(window.WebViewBridge, location.pathname)
      } else if (window.webkit && window.webkit.messageHandlers.pageGoBack) {
        window.webkit.messageHandlers.pageGoBack.postMessage(location.pathname)
      }
    } else if (history.action === 'PUSH') {
      if (window.WebViewBridge) {
        window.WebViewBridge?.pageGoForward?.call(window.WebViewBridge, location.pathname)
      } else if (window.webkit && window.webkit.messageHandlers.pageGoForward) {
        window.webkit.messageHandlers.pageGoForward.postMessage(location.pathname)
      }
    }
  }

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        classNames="fade"
        timeout={{ enter: 500, exit: 0 }}
      >
        <Switch location={location}>
          <Route exact path="/store" >
            <KeepAlive><Store /></KeepAlive>
          </Route>
          <Route path="/sany" component={Sany} />          
          <Route exact path="/search" component={Search} />
          <Route exact path="/select-store" component={SelectStore} />
          <Route exact path="/order-detail/:order_sn" component={OrderDetail} />
          <Route exact path="/lookcode" component={LookCode} />
          <Route exact path="/orderRefund" component={OrderRefund} />
          <Route exact path="/goods-detail/:id" component={GoodsDetail} />
          <Route exact path="/order-list/:index" component={OrderList} />
          <Route path="/fillorder" component={OrderRoute} />
          <Route path="/shoppingcar" component={ShoppingCar} />
          <Route path="/payment" component={Payment} />
          <Route path="/book" component={Book} />
          <Route path="/switch-bed" component={SwitchBed} />
          <Route path="/person-setting" component={PersonSetting} />
          <Route path="/change-pwd" component={ChangePwd} />
          <Route path="/my-integral" component={MyIntegral} />
          <Route path="/earn-point" component={EarnPoints} />
          <Route path="/mycoupon" component={MyCoupon} />
          <Route path="/basic-info" component={BasicInformation} />
          <Route path="/notice" component={Notification} />
          <Route path="/repair" component={Repair} />
          <Route path="/service-agreement" component={ServiceAgreement} />
          <Route path="/protocol" component={Protocol} />
          <Route path="/about" component={AboutUs} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/download-page" component={DownloadPage} />
          <Route exact path="/" >
            <KeepAlive><Store /></KeepAlive>
          </Route>
          <Route component={NoMatch} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  )
})
